import { axiosInstanceWithToken } from 'utils/axios';

export const fetchCountryStates = async (id: string) =>
  axiosInstanceWithToken().get<{ name: string; iso2: string }[]>(`countries/${id}/states`);
